import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function HueBedroom() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>HueBedroom Dataset</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>The HueBedroom Dataset was developed as a component of my master's thesis and later featured in my publication titled "<b>Color Transfer of 3D Point Clouds XR Applications</b>". This dataset provides 3D reconstructions of a single room under varying lighting conditions, achieved by illuminating the space with hue color lamps. It serves as a valuable ground truth for evaluating color transfer algorithms.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
          <ul>
            <li>A bedroom scene, encompassing the floor and two walls.</li>
            <li>Six aligned point clouds, each showcasing diverse illumination settings.</li>
            <li>Reconstruction achieved using <a href="https://github.com/mp3guy/ElasticFusion">ElasticFusion</a> in conjunction with KinectV1.</li>
            <li>Each point cloud comprises 700-800K vertices and is approximately 50MB in size.</li>
          </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/hue_bedroom.webp'}/>
        </BlockContent>
      </Block>



      <Block colorTheme="light" gridTemplateColumns="1200px"> 
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/HueDataset')}>Download</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default HueBedroom;